<div
  (click)="!isAvailable() ? null : addToCart()"
  class="h-full"
>
  <div class="relative flex h-full w-full flex-col justify-between gap-2">
    @if (product().description?.length || product().allergens?.length) {
      <i
        (click)="!isAvailable() ? null : showProductModal(); $event?.stopPropagation?.()"
        class="icon icon-c-info-3 pointer-events-auto absolute right-0 top-0 z-10 content-center pb-3 pl-3 text-center text-xl font-semibold"
        [style.color]="textColor() | contentBuilderColor"
        [class.opacity-50]="!isAvailable()"
      ></i>
    }
    <p
      class="mr-9 line-clamp-2 break-words font-accent text-xl font-bold xl:text-md"
      [style.color]="textColor() | contentBuilderColor"
    >
      {{ product()[ProductKeys.Name] }}
    </p>
    <div class="relative flex w-full flex-row gap-2">
      <div class="flex h-full min-h-24 w-full flex-col justify-between">
        <p
          class="line-clamp-4 min-h-[5rem] text-left font-base text-base leading-5"
          [style.color]="textColor() | contentBuilderColor"
        >
          {{ product()[ProductKeys.Description] }}
        </p>
        <div class="self-start">
          <div
            *ngIf="!product()[ProductKeys.PriceToDisplay]"
            class="mt-2 flex flex-row gap-2 text-base xl:mt-3 xl:text-md"
            [style.color]="textColor() | contentBuilderColor"
          >
            <ng-container *ngIf="displayDiscount(); else priceOnly">
              <app-price-atom
                class="mr-1"
                [amount]="product()[ProductKeys.Discount] ?? 0"
                [bold]="true"
              ></app-price-atom>
              <app-tag-atom
                class="mr-1"
                color="success"
                text="-{{ discountPercentage() }}%"
                *ngIf="product()[ProductKeys.Price]"
              ></app-tag-atom>
              <app-price-atom
                class="mr-1"
                [amount]="product()[ProductKeys.Price]"
                [discount]="true"
                [bold]="true"
                *ngIf="product()[ProductKeys.Price]"
              ></app-price-atom>
            </ng-container>
            <ng-template #priceOnly>
              <app-price-atom
                class="mr-1"
                [amount]="product()[ProductKeys.Price]"
                [bold]="true"
              ></app-price-atom>
            </ng-template>
          </div>
          <div
            *ngIf="product()[ProductKeys.PriceToDisplay]"
            class="mt-2 text-base xl:mt-3 xl:text-md"
          >
            <span class="mr-1"> {{ product()[ProductKeys.PriceToDisplay] }}</span>
          </div>
        </div>
      </div>
      <div class="relative flex min-h-24 w-36 items-end overflow-hidden rounded-lg object-cover">
        <div
          class="absolute bottom-0 h-24 w-full rounded-lg"
          [appRadialGradient]="product()[ProductKeys.Images]?.thumbnail?.colors"
        ></div>
        @if (product().images?.thumbnail?.url) {
          <img
            class="relative z-10 w-28 rounded-lg object-cover"
            [src]="product().images?.thumbnail?.url"
            [alt]="product()[ProductKeys.Name]"
          />
        }
      </div>
    </div>
  </div>
</div>

<!-- Unavailable Overlay -->
<div
  *ngIf="!isAvailable()"
  class="absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-black bg-opacity-50"
>
  <span
    class="absolute right-[53px] top-[122px] max-w-[100px] translate-x-1/2 text-sm font-bold text-white"
    >{{ '_.UNAVAILABLE' | translate }}</span
  >
</div>
